const state = {
  isLogin: false,
  _id: null,
  email: "",
  providerId: null,
  providerName: "",
  username: "",
  mobileNo: "",
  // 대시보드 카운트
  todayScheduleCount: 0,
  pendingEstimateCount: 0,
  recentReviewCount: 0,
  unreadNotificationCount: 0,
  navbarState: "0",
  selectedProviderChatId: null,
};
export default state;
